import Rete from 'rete';

import { distSocket, selectGrowthRate } from './index';

import samplingNumber from '../../util/density/samplingNumber';
import timeSlices from '../../util/density/timeSlices';

import NumControl from './NumControl';
import SelectControl from './SelectControl';
import ConditionalNumControl from './ConditionalNumControl';
import ButtonControl from './ButtonControl';
import DistPreviewControl from './DistPreviewControl';


import Vue from 'vue';
import { v4 as uuidv4 } from 'uuid';


export default class ExpDistComponent extends Rete.Component {

	constructor(){
		super("Exponential Dist.");
		this.path = ["Distribution"];
		this.contextMenuName = "Exponential";
	}

	builder(node) {
		let out = new Rete.Output('dist', "Output", distSocket);


		// Below was used for debugging
/* 		let optionsList = [];

		let ctrl = new SelectControl(this.editor, 'module', false, optionsList);

		console.log('Change function', ctrl.component.methods); */

		return node
			.addControl(new NumControl(this.editor, 'mu'))
			.addControl(new SelectControl(this.editor, 'timetype', false, selectGrowthRate))
			.addControl(new ConditionalNumControl(this.editor, 'growthrate'))
			.addControl(new ButtonControl(this.editor, 'parameters', false, node.id, ['mu']))
			.addControl(new DistPreviewControl(this.editor, 'preview', true, node.id))
			.addOutput(out);
	}

	destroyed(node){

		// console.log(`Node ${node.id} was destroyed.`)

		// Remove all event listeners -- otherwise they will respond even if node does no longer exist

	}	

	async worker(node, inputs, outputs) {

		// Get all predecessors
		let predecessors = [];

		// Iterate over sockets, and inputs to collect all predecessors (their UUIDs)
		for (let [socket, inputArray] of Object.entries(inputs)) {
			for (let i = 0; i < inputArray.length; i++){
				if (inputArray[i]){
					predecessors.push(inputArray[i]['predecessor']);
				} else {
					console.log('A predecessor could not be determined. Likely because an embedded module is currently open. Any tree view will then be incomplete.')
				}
			}
		}

		
		// find control element
		let nodeSearch = this.editor.nodes.find(n => n.id == node.id);
		let growthRate = node.data.growthrate?node.data.growthrate:0;
		let growthSelector = node.data.timetype?node.data.timetype:'constant';
		let controlsElement = nodeSearch?nodeSearch.controls:undefined;
		
		if(nodeSearch) {
		
			// change visibility of growthrate input
			if( growthSelector == 'growthrate') {
				controlsElement.get('growthrate').setVisibility(true);
				controlsElement.get('parameters').setVisibility(false);
			} else if( growthSelector == 'individual') {
				controlsElement.get('parameters').setVisibility(true);
				controlsElement.get('growthrate').setVisibility(false);
			} else {
				controlsElement.get('growthrate').setVisibility(false);
				controlsElement.get('parameters').setVisibility(false);
			}
		}
		
		// link input values directly to parameter data object used with more periods
		node.data.parameters = node.data.parameters?node.data.parameters:[{}];
		node.data.parameters[0].mu = node.data.mu;	
		
		// ensure compatability and convert old values to new ones
		for (let k=2; k<=12; k++){
			if(node.data.parameters[k-1] == undefined && (node.data['mu'+k])){
				node.data.parameters[k-1]={};
				if(node.data['mu'+k]){
					node.data.parameters[k-1].mu = node.data['mu'+k];
					delete node.data['mu'+k];
				}
			}
		}
		
		// create random values and fill array / matrix
		let matrix = [];
		let timeSliceValue = timeSlices();
		let samplingValue = samplingNumber();
		
		for (let i = 0; i < timeSliceValue; i++) {
			let array = [];
			let GrowthFactor = Math.pow(1+growthRate,i);
			let muValue;
			if(growthSelector == 'individual'){
				muValue = node.data.parameters[i]?node.data.parameters[i].mu:undefined;
			} else {
				muValue = node.data.parameters[0].mu;
			}
			//bug fix to corect string mistake in popup
			if(typeof muValue == "string") muValue = parseFloat(muValue);
			
			for (let j = 0; j < samplingValue; j++) {
				let calculatedValue = -muValue*Math.log(1-Math.random());
				
				if(growthSelector=='growthrate'){
					calculatedValue = calculatedValue * GrowthFactor;
				}
				array.push(calculatedValue);
			}
			matrix.push(array);
		}
		// update preview if node on screen (in editor)
		if (controlsElement) {
			controlsElement.get('preview').setValue(matrix);
		}


		// NEW
		// Generate a new UUID for this node instance(!)
		const nodeUUID = uuidv4();

		outputs['dist'] = {
			predecessor: nodeUUID,
			data: matrix,
		};

		let hasPredecessors = predecessors.length > 0 ? true : false;

		// Write global node data object
		Vue.prototype.$globalSharedData.globalNodeData[nodeUUID] = {
			hasPredecessors: hasPredecessors,
			predecessors: predecessors,
			nodeID: node.id,
			data: matrix,
			name: node.data.title,
			nodeFunction: node.name,
			module: undefined,
			nodeData: node.data,
		}

	}
}
